﻿import { UTL } from "../util/classes";
import { PopupPlusStyleRecord, PopupPlusAuxFunctions } from "./popupPlus_Aux"; // <--- ייבוא הפונקציה הספציפית
import { MyGeneralTimer } from "./MyGeneralTimer";

export class AnnouncePlus {
    private static IS_INITIALZED: boolean = false;
    // AnnouncePlus,NotfiyPlus    בשלב זה קיים רק ב IS_OPENED המשתנה
    // AnnouncePlus,NotfiyPlus    בשלב זה קיים רק ב IS_OPENED המשתנה
    private static IS_OPENED: boolean = false;
    // AnnouncePlus,NotfiyPlus    בשלב זה קיים רק ב IS_OPENED המשתנה
    // AnnouncePlus,NotfiyPlus    בשלב זה קיים רק ב IS_OPENED המשתנה
    // AnnouncePlus,NotfiyPlus    בשלב זה קיים רק ב IS_OPENED המשתנה


    private static overlay_element: HTMLDivElement = null;
    private static popup_element: HTMLDivElement = null;
    private static caption_element: HTMLDivElement = null;
    private static text_element: HTMLDivElement = null;

    public static par_text_str: string = "";
    //public static par_caption_exist: boolean = false;
    public static par_caption_str: string = "";
    public static par_style_rec: PopupPlusStyleRecord = null;

    private static overlay_keydown(event: KeyboardEvent): void {
        if (PopupPlusAuxFunctions.keydown_event_should_preventDefault(event) == true) {
            event.preventDefault(); // לשים את הפקודה הזאת gemini :הערה
            event.stopPropagation(); // לשים את הפקודה הזאת gemini :הערה
        }
    }

    static overlay_mousedown(event: MouseEvent) {
        //---------------------------------------------------------------------------------------------
        //                               ."event.preventDefault();" שים לב. אנחנו מפעילים באירוע הזה את
        // למה? בגלל שאם לא מבצעים זאת אז לחיצה על העכבר במקום כלשהו גורמת לפוקוס לעבור למקום אחר כלשהו
        //---------------------------------------------------------------------------------------------
        event.preventDefault(); // הלך לאיבוד focus ללא השורה הזאת ה
    }

    private static perform_INITIALZE_INA() {
        const freezed_IS_INITIALZED: boolean = AnnouncePlus.IS_INITIALZED;
        if (freezed_IS_INITIALZED == false) {
            AnnouncePlus.overlay_element = document.createElement("div");;
            AnnouncePlus.popup_element = document.createElement("div");;
            AnnouncePlus.caption_element = document.createElement("div");;
            AnnouncePlus.text_element = document.createElement("div");;
            //-----------------------------
            AnnouncePlus.overlay_element.appendChild(AnnouncePlus.popup_element);
            AnnouncePlus.popup_element.appendChild(AnnouncePlus.caption_element);
            AnnouncePlus.popup_element.appendChild(AnnouncePlus.text_element);
            //-----------------------------
            AnnouncePlus.overlay_element.addEventListener("keydown", AnnouncePlus.overlay_keydown);
            AnnouncePlus.overlay_element.addEventListener("mousedown", AnnouncePlus.overlay_mousedown);
            //-----------------------------

            AnnouncePlus.IS_INITIALZED = true;
        }
    }



    public static prepare(): void {
        AnnouncePlus.perform_INITIALZE_INA();

        if (true) {

            //xyz();
            PopupPlusAuxFunctions.apply_style_to_overlay_element(AnnouncePlus.overlay_element, AnnouncePlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_popup_element(AnnouncePlus.popup_element, AnnouncePlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_caption_element(AnnouncePlus.caption_element, AnnouncePlus.par_style_rec);
            PopupPlusAuxFunctions.apply_style_to_text_element(AnnouncePlus.text_element, AnnouncePlus.par_style_rec);
        }

        if (true) {
            if (AnnouncePlus.par_caption_str == null) {
                AnnouncePlus.caption_element.style.display = "none";
            }
            if (AnnouncePlus.par_caption_str != null) {
                AnnouncePlus.caption_element.style.display = "block";
            }
        }
        if (true) {
            AnnouncePlus.caption_element.innerText = AnnouncePlus.par_caption_str;
            //AnnouncePlus.text_element.innerText = AnnouncePlus.par_text_str;
            AnnouncePlus.text_element.innerHTML = AnnouncePlus.par_text_str; //innerHTML ל innerText שינינו מ
            //AnnouncePlus.text_element.style.fontSize = AnnouncePlus.par_style_rec.text_element_fontSize;
        }

    }

    public static Open(p_text_str: string, p_caption_str: string = null, p_style_rec: PopupPlusStyleRecord = null): void {
        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה
        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה
        //  overlay_BackgroundColor = rgba(0, 0, 0, 0.5)" :אפשר להציב overlay להזכירך: אם לא רוצים לראות את ה


        // Async אינו Announce שים לב ש
        // Async אינו Announce שים לב ש
        // Async אינו Announce שים לב ש
        // Async אינו Announce שים לב ש

        // או פשוט לספק פרמטר אחד של הטקסט caption בפרמטר של ה null יש להציב caption אם לא רוצים לראות את ה
        // או פשוט לספק פרמטר אחד של הטקסט caption בפרמטר של ה null יש להציב caption אם לא רוצים לראות את ה

        const freezed_IS_OPENED = AnnouncePlus.IS_OPENED;

        if (p_style_rec != null && (p_style_rec instanceof PopupPlusStyleRecord) == false) {
            alert("AnnouncePlus.p_style_rec is not PopupPlusStyleRecord");
            return;
        }

        // באופן תקין גם אם האובייקט כבר פתוח Open שים לב שהחל מתאריך 1.5.2026 אנחנו מאפשרים לבצע
        // באופן תקין גם אם האובייקט כבר פתוח Open שים לב שהחל מתאריך 1.5.2026 אנחנו מאפשרים לבצע
        // באופן תקין גם אם האובייקט כבר פתוח Open שים לב שהחל מתאריך 1.5.2026 אנחנו מאפשרים לבצע
        /*
        if (AnnouncePlus.overlay_element !== null && AnnouncePlus.overlay_element !== undefined && AnnouncePlus.overlay_element.parentNode !== null) {
            alert("AnnouncePlus.Open().Error: AnnouncePlus is already open.");
            return;
        }
        */

        // כאן יש להוסיף בדיקות בהמשך
        // כאן יש להוסיף בדיקות בהמשך
        // כאן יש להוסיף בדיקות בהמשך
        AnnouncePlus.par_text_str = p_text_str;
        AnnouncePlus.par_caption_str = p_caption_str;
        AnnouncePlus.par_style_rec = p_style_rec;
        if (AnnouncePlus.par_style_rec == null) {
            AnnouncePlus.par_style_rec = PopupPlusAuxFunctions.create_rec_style_v1("ltr", "20px", false);
        }
        //AnnouncePlus.pseudo_executor_function(null, null);

        AnnouncePlus.prepare();
        if (freezed_IS_OPENED == false) {
            document.body.appendChild(AnnouncePlus.overlay_element);
            UTL.center_popup_element_inside_overlay_element(AnnouncePlus.popup_element, AnnouncePlus.overlay_element);
        }
        AnnouncePlus.startTime = Date.now();
        if (p_style_rec.display_progress_milliseconds == true) {
            MyGeneralTimer.Start(AnnouncePlus.RespondToTimer);
        }
        if (p_style_rec.display_progress_milliseconds == false) {
            MyGeneralTimer.Stop();
        }
        AnnouncePlus.IS_OPENED = true;
    }

    public static Close(): void {

        // בשלב זה אנחנו לא רוצים הערות שם שגוי
        // בשלב זה אנחנו לא רוצים הערות שם שגוי

        if (AnnouncePlus.overlay_element === null || AnnouncePlus.overlay_element === undefined) {
            /*alert("AnnouncePlus.Close().Error: overlay_element is null or undefined.");*/
            return;
        }

        if (AnnouncePlus.overlay_element.parentNode === null) {
            /*alert("AnnouncePlus.Close(). error may be you didnt open or did multiple close");*/
            return;
        }

        if (AnnouncePlus.overlay_element.parentNode !== document.body) {
            /*alert("AnnouncePlus.Close().Error: overlay_element is not a child of document.body.");*/
            return;
        }


        document.body.removeChild(AnnouncePlus.overlay_element);
        MyGeneralTimer.Stop();
        AnnouncePlus.IS_OPENED = false;
    }

    public static startTime: number = Date.now();

    public static RespondToTimer() {
        if (AnnouncePlus.IS_OPENED == true) {
            console.log("AnnouncePlus.RespondToTimer()");
            const now = Date.now();
            const elapsedMs = now - AnnouncePlus.startTime;
            const tenths = Math.floor((elapsedMs % 1000) / 100);
            const seconds = Math.floor(elapsedMs / 1000);
            //AnnouncePlus.text_element.innerText = AnnouncePlus.par_text_str + " <br> " + `${seconds}.${tenths}`;
            AnnouncePlus.text_element.innerHTML = AnnouncePlus.par_text_str + " <br> " + `${seconds}.${tenths}`;
        }
    }
}
